import { all } from "redux-saga/effects";
import { WatcherEcommerceApp } from "../redux/ecommerce";

export default function* rootSagas() {
  yield all([WatcherEcommerceApp()]);
}
